import { Error } from "@progress/kendo-react-labels";
import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import { Input } from "@progress/kendo-react-inputs";

export const FormNumericInput = (fieldRenderProps: FieldRenderProps) => {
  const { validationMessage, visited, label, id, valid, disabled, ...others } =
    fieldRenderProps;

  return (
    <FieldWrapper>
      <Input
        id={id}
        label={label}
        valid={valid}
        disabled={disabled}
        inputMode="numeric"
        pattern="[0-9]"
        {...others}
      />

      {visited && validationMessage && <Error>{validationMessage}</Error>}
    </FieldWrapper>
  );
};
